import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import type { ApplicationSdk } from '../sdk';
import { DEFAULT_MAX_ENTRIES } from '../constants';

class TmpEmployee {
    private sdk: ApplicationSdk;
    public loading: boolean = false;
    public employeeList: Array<any> = [];

    constructor(sdk: ApplicationSdk) {
        makeObservable(this, {
            loading: observable,
            employeeList: observable,
            fetch: action,
            all: computed,
        });
        this.sdk = sdk;
    }

    public async fetch(): Promise<void> {
        runInAction(() => {
            this.loading = true;
        });

        const employeeList: any = await this.sdk.fetchApi('employee', 'query', {
            format: 'simple',
            limit: 999,
        });

        runInAction(() => {
            this.loading = false;

            if (employeeList?.status === 200) {
                this.employeeList = (employeeList.json.data || this.employeeList || []).map(
                    (employee: any) => ({
                        ...employee,
                        name: `${employee.firstname} ${employee.lastname}`,
                    })
                );
            }
        });
    }

    get all() {
        return {
            filter: (search: string, maxEntries: number = DEFAULT_MAX_ENTRIES) => {
                return this.employeeList
                    .filter((employee: any) => {
                        return employee.name.toLowerCase().includes(search.toLowerCase());
                    })
                    .slice(0, maxEntries); // Limit the results to maxEntries
            },
            data: this.employeeList,
        };
    }
}

export default TmpEmployee;
